import { render, staticRenderFns } from "./EventAlertModal.vue?vue&type=template&id=638a46a2&"
import script from "./EventAlertModal.vue?vue&type=script&lang=js&"
export * from "./EventAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./EventAlertModal.vue?vue&type=style&index=0&id=638a46a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports